import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import { Formik, Form as FormikForm } from 'formik';
import FormField from '../layout/FormField';

import * as Yup from 'yup';

const TIER_SCALING = {
    Silver: 1.5,
    Gold: 1.8,
    Platinum: 2
};

const RewardPointSetting = () => {
    const { getToken } = useAuth();
    const [rewardConfig, setRewardConfig] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        getRewardSettings();
    }, []);

    const validate = Yup.object({
        pointsPer100Km: Yup.object({
            bus: Yup.object({
                Bronze: Yup.number().required('Required')
            }),
            train: Yup.object({
                Bronze: Yup.number().required('Required')
            })
        }),
        pointsToDollar: Yup.object({
            100: Yup.number().required('Required')
        })
    });

    const getRewardSettings = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setRewardConfig(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };

    const handleSubmit = async (values, actions) => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .updateRewardSettings(token, values)
                .then((res) => {
                    if (res?.code == 200) {
                        toast.success('Rewards setting udpated successfully');
                        navigate('/');
                    }
                })
                .catch((err) => {});
        } else {
            toast.error('Oops...! Something went wrong');
        }
    };

    const getTierValues = (bronzeValue) => {
        const bronze = Number(bronzeValue) || 0;
        return {
            Bronze: bronze,
            Silver: Math.round(bronze * TIER_SCALING.Silver),
            Gold: Math.round(bronze * TIER_SCALING.Gold),
            Platinum: Math.round(bronze * TIER_SCALING.Platinum)
        };
    };

    return (
        <Row className="d-flex justify-content-center">
            <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 rounded m-3">
                <Formik
                    initialValues={{
                        pointsPer100Km: rewardConfig?.pointsPer100Km || {
                            bus: { Bronze: '', Silver: '', Gold: '', Platinum: '' },
                            train: { Bronze: '', Silver: '', Gold: '', Platinum: '' }
                        },
                        pointsToDollar: rewardConfig?.pointsToDollar || {
                            200: '',
                            500: '',
                            1000: '',
                            1500: ''
                        }
                    }}
                    validationSchema={validate}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {(formik) => {
                        const busTiers = getTierValues(formik.values.pointsPer100Km.bus.Bronze);
                        const trainTiers = getTierValues(formik.values.pointsPer100Km.train.Bronze);

                        return (
                            <FormikForm
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={12} className="mb-3">
                                        <div className="config-form-container">
                                            <label className="config-legend-label">Points Per 100 Km - Bus</label>
                                            <Row>
                                                {['Bronze', 'Silver', 'Gold', 'Platinum'].map((tier) => (
                                                    <Col xs={12} sm={12} md={3} lg={3} className="mb-3" key={`bus-${tier}`}>
                                                        {tier === 'Bronze' ? (
                                                            <FormField
                                                                className="form-control common-input"
                                                                label={`${tier} Tier`}
                                                                name={`pointsPer100Km.bus.${tier}`}
                                                                type="number"
                                                                placeholder={`Enter points for ${tier}`}
                                                                value={formik.values.pointsPer100Km.bus[tier]}
                                                                onChange={formik.handleChange}
                                                            />
                                                        ) : (
                                                            <Form.Group>
                                                                <Form.Label className="mb-0">{`${tier} Tier`}</Form.Label>
                                                                <div
                                                                    className="form-control common-input text-primary"
                                                                    style={{ backgroundColor: '#e7f3fe', opacity: 1 }}
                                                                >
                                                                    {busTiers[tier]}
                                                                </div>
                                                            </Form.Group>
                                                        )}
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>

                                        <div className="config-form-container">
                                            <label className="config-legend-label">Points Per 100 Km - Train</label>
                                            <Row>
                                                {['Bronze', 'Silver', 'Gold', 'Platinum'].map((tier) => (
                                                    <Col xs={12} sm={12} md={3} lg={3} className="mb-3" key={`train-${tier}`}>
                                                        {tier === 'Bronze' ? (
                                                            <FormField
                                                                className="form-control common-input"
                                                                label={`${tier} Tier`}
                                                                name={`pointsPer100Km.train.${tier}`}
                                                                type="number"
                                                                placeholder={`Enter points for ${tier}`}
                                                                value={formik.values.pointsPer100Km.train[tier]}
                                                                onChange={formik.handleChange}
                                                            />
                                                        ) : (
                                                            <Form.Group>
                                                                <Form.Label className="mb-0">{`${tier} Tier`}</Form.Label>
                                                                <div
                                                                    className="form-control common-input text-primary"
                                                                    style={{ backgroundColor: '#e7f3fe', opacity: 1 }}
                                                                >
                                                                    {trainTiers[tier]}
                                                                </div>
                                                            </Form.Group>
                                                        )}
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>

                                        <div className="config-form-container">
                                            <label className="config-legend-label">Points to Dollar Conversion</label>
                                            <Row>
                                                {[100].map((points) => (
                                                    <Col xs={12} sm={12} md={3} lg={3} className="mb-3" key={`points-${points}`}>
                                                        <FormField
                                                            className="form-control common-input"
                                                            label={`${points} Points`}
                                                            name={`pointsToDollar.${points}`}
                                                            type="number"
                                                            placeholder={`Enter $ value for ${points} points`}
                                                            value={formik.values.pointsToDollar[points]}
                                                            onChange={formik.handleChange}
                                                        />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="text-end justify-content-end d-flex">
                                    <Link to="/">
                                        <Button className="theme-cancel-btn me-3">Cancel</Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Save
                                    </Button>
                                </div>
                            </FormikForm>
                        );
                    }}
                </Formik>
            </Col>
        </Row>
    );
};

export default RewardPointSetting;
